import { type ReactNode, useEffect, useRef } from 'react';

// EventMap 증강을 컴파일에 포함시킨다 — 빠지면 이벤트가 조용히 미등록된다.
import './consts/events.quiz-board-landing';
import { trackEvent } from '@zep/logger/tracking';
import Footer from '@/components/Footer';
import { useIsLoggerUserInfoSet } from '@/lib/auth/UserContext';
import { BoardLandingBottomCta, BoardLandingFaq, BoardLandingFeatures, BoardLandingHero, BoardLandingIntro, BoardLandingSamples, BoardLandingSectionImpression, BoardLandingStats } from './components';
import { BOARD_LANDING_SECTIONS, type BoardLandingSection } from './consts';

/**
 * 섹션 이름 → 렌더할 내용. `BOARD_LANDING_SECTIONS` 를 Record 키로 강제해서
 * 섹션을 추가하면 여기 빠뜨린 것이 컴파일 에러로 잡힌다.
 */
const SECTION_CONTENT: Record<BoardLandingSection, ReactNode> = {
  hero: <BoardLandingHero />,
  intro: <BoardLandingIntro />,
  stats: <BoardLandingStats />,
  samples: <BoardLandingSamples />,
  features: <BoardLandingFeatures />,
  faq: <BoardLandingFaq />,
  bottom_cta: <BoardLandingBottomCta />
};
function usePageViewTracking() {
  const isLoggerUserInfoSet = useIsLoggerUserInfoSet();
  const hasFired = useRef(false);
  useEffect(() => {
    // 유저 컨텍스트보다 먼저 나가면 같은 이벤트가 global prop 유/무로 섞인다.
    if (!isLoggerUserInfoSet || hasFired.current) return;
    hasFired.current = true;
    trackEvent('board_landing_page_view', {});
  }, [isLoggerUserInfoSet]);
}
export function BoardLandingPageView() {
  usePageViewTracking();
  return <>
      <div className="flex flex-col">
        {BOARD_LANDING_SECTIONS.map((section, index) => <BoardLandingSectionImpression key={section} section={section} index={index}>
            {SECTION_CONTENT[section]}
          </BoardLandingSectionImpression>)}
      </div>
      <Footer data-sentry-element="Footer" data-sentry-source-file="BoardLandingPageView.tsx" />
    </>;
}